import React from "react";
import { separatorStyle } from "./index.css";

export const Separator: React.FC = () => {
  return <div className={separatorStyle} />;
};
